import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import type { APIData, Service } from 'webapp-types';
import { RcItem } from 'webapp/enums/enums';
import { getRelativeTime } from 'webapp/utils/number';

import Serviced from 'webapp/models-custom/serviced';
import type SourceType from 'webapp/models-custom/source-type';

import type { SystemNotification } from 'webapp/services/app-notifications';

export default class ResolutionCenterItem extends Serviced {
	@service declare timer: Service.Timer;
	@service('model-manager/source-types')
	declare mmSourceTypesService: Service.ModelManager.SourceTypes;

	@tracked id: number | undefined; // these three only for messages from BE (not system notifications)
	@tracked timestamp: number | undefined;
	@tracked createdById: number | undefined;
	@tracked title: string;
	@tracked boardIds: number[] = []; // only REPORT_SHARE type currently supports more than 1 item in the array
	@tracked sourceId: number | null = null;
	@tracked text: string;
	@tracked type: number;
	@tracked params: APIData.AppNotifications.ResolutionCenterParams = {};

	@tracked activeFilter: string[] = [];

	constructor(
		model: Partial<APIData.AppNotifications.ResolutionCenterMessage> &
			SystemNotification & { sourceId?: number },
	) {
		super();

		this.id = model.id;
		this.timestamp = model.timestamp;
		this.createdById = model.createdById;
		this.title = model.title;
		this.text = model.text;
		this.type = model.type;
		if (model.boardIds) {
			this.boardIds = model.boardIds;
		}
		if (model.sourceId) {
			this.sourceId = model.sourceId;
		}
		if (model.params) {
			this.params = model.params;
		}
	}

	get isTransferedBoardType(): boolean {
		return RcItem.BOARD_SHARE === this.type;
	}

	get isTransferedReportType(): boolean {
		return RcItem.REPORT_SHARE === this.type;
	}

	get prioclass(): string {
		return this.isTransferedBoardType ? 'info' : 'prio1';
	}

	get timeText(): string {
		this.timer.observe();

		let timeText = '';
		if (this.timestamp) {
			timeText = getRelativeTime(this.timestamp);
		}
		return timeText;
	}

	get shownText(): string {
		let text = this.text;

		if (this.type === RcItem.BOARD_SHARE && this.params.isPublicTemplate) {
			const titleMatch = /<strong>(.*)<\/strong>/.exec(this.text);
			let title = '';
			if (titleMatch) {
				title = titleMatch[0];
			}
			text = `Dashboard ${title} has been added to your account.`;
		}

		return text;
	}

	get acceptText(): string {
		return this.params.isPublicTemplate ? 'Connect' : 'Accept';
	}

	get sourceType(): SourceType | null {
		let sourceType = null;

		if (this.params?.dataSourceTypeId) {
			sourceType = this.mmSourceTypesService.findModelById(this.params.dataSourceTypeId);
		}

		return sourceType;
	}
}
